// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","firstRow":"Footer_firstRow__mPI8o","secondCol":"Footer_secondCol__qvr0t","container":"Footer_container__EfBXz","secondRow":"Footer_secondRow__Vn-CV"};